
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.667 39.667V7A4.668 4.668 0 0035 2.333H21.56a7 7 0 00-4.947 2.054L6.72 14.28a6.996 6.996 0 00-2.053 4.947v20.44a4.666 4.666 0 004.666 4.666H35a4.667 4.667 0 004.667-4.666zM9.333 21H21a2.333 2.333 0 002.333-2.333V7H35v32.667H9.333V21zm35-9.333v32.666A4.666 4.666 0 0139.667 49H14a4.668 4.668 0 004.667 4.667h21c5.154 0 9.333-4.179 9.333-9.334v-28a4.667 4.667 0 00-4.667-4.666z","fill-rule":"evenodd"}})])
          )
        }
      }
    